import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
import Industry from '@/components/industry/index'
import Information from '@/components/information/index'
import Answer from '@/components/answer/index'
import Cha from '@/components/Cha/index'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/components/industry',
      name: 'Industry',
      component: Industry
    },
    {
      path: '/components/information',
      name: 'Information',
      component: Information
    },
    {
      path: '/components/answer',
      name: 'Answer',
      component: Answer
    },
    {
      path: '/components/cha',
      name: 'Cha',
      component: Cha
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js